import React, { useEffect } from "react";
import { ShortcutFormStyled } from "./styled";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Inputs, Buttons } from "components";

const ShortcutForm = ({
  activityOptions,
  activityFormOptions,
  surveyOptions,
  initialValues,
  onSubmit,
  onCancel,
}) => {
  const schema = yup.object().shape({
    // test: yup.string().required("New password is required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { fields } = useFieldArray({
    control,
    name: "shortcut_list",
  });

  const watchShortcutField = watch("shortcut_list");

  useEffect(() => {
    if (initialValues) {
      reset({ ...initialValues });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const _handleChangeMainCate = (index) => {
    setValue(`shortcut_list.${index}.sub_category`, "");
    setValue(`shortcut_list.${index}.action_ref_id`, null);
  };

  const _handleChangeSubCate = (index) => {
    setValue(`shortcut_list.${index}.action_ref_id`, null);
  };

  const _renderSubCategory = (e) => {
    const temp = cateOpt.find((f) => f.value === e);
    if (!temp) {
      return [];
    } else {
      return temp.subCate;
    }
  };
  const _renderActionRefID = (e) => {
    switch (e) {
      case "1":
        return activityFormOptions;
      case "2":
        return activityOptions;
      case "8":
        return surveyOptions;
      default:
        return [];
    }
  };

  return (
    <ShortcutFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        {fields.map((item, index) => (
          <div key={item._id} className="box_col_2">
            <div className="obj_switch">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.InputSwitch
                    {...field}
                    errors={
                      errors?.shortcut_list &&
                      errors?.shortcut_list[index]?.is_active
                    }
                  />
                )}
                name={`shortcut_list.${index}.is_active`}
              />
              <span>ShortCut {index + 1}</span>
            </div>
            <div className="box_select">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Dropdown
                    {...field}
                    options={cateOpt}
                    placeholder="เลือกหมวดหลัก"
                    onChaneCustom={() => {
                      _handleChangeMainCate(index);
                    }}
                    errors={
                      errors?.shortcut_list &&
                      errors?.shortcut_list[index]?.main_category
                    }
                  />
                )}
                name={`shortcut_list.${index}.main_category`}
              />
              {(watchShortcutField[index].main_category === "1" ||
                watchShortcutField[index].main_category === "2" ||
                watchShortcutField[index].main_category === "4") && (
                <>
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <Inputs.Dropdown
                        {...field}
                        options={_renderSubCategory(
                          watchShortcutField[index].main_category
                        )}
                        placeholder="เลือกหมวดรอง"
                        onChaneCustom={() => {
                          _handleChangeSubCate(index);
                        }}
                        errors={
                          errors?.shortcut_list &&
                          errors?.shortcut_list[index]?.sub_category
                        }
                      />
                    )}
                    name={`shortcut_list.${index}.sub_category`}
                  />
                  {watchShortcutField[index].sub_category !== "6" && (
                    <Controller
                      control={control}
                      render={({ field }) => (
                        <Inputs.Dropdown
                          {...field}
                          options={_renderActionRefID(
                            watchShortcutField[index].sub_category
                          )}
                          placeholder="เลือก รายการที่ Active"
                          errors={
                            errors?.shortcut_list &&
                            errors?.shortcut_list[index]?.action_ref_id
                          }
                        />
                      )}
                      name={`shortcut_list.${index}.action_ref_id`}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        ))}
        <div className="btn_zone">
          {/* <div className="w120">
            <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
          </div> */}
          <div className="w120">
            <Buttons.BgStandard
              type="submit"
              label="Update"
              // disabled={initialValues && !initialValues.is_edit}
            />
          </div>
        </div>
      </form>
    </ShortcutFormStyled>
  );
};

const cateOpt = [
  {
    label: "กิจกรรม",
    value: "1",
    subCate: [
      {
        label: "Online form",
        value: "1",
      },
      {
        label: "Activity",
        value: "2",
      },
      // {
      //   label: "News",
      //   value: "3",
      // },
    ],
    actSub: [
      {
        label: "แสดงเฉพาะรายการที่ Active",
        value: "Active",
      },
    ],
  },
  {
    label: "สำคัญ",
    value: "2",
    subCate: [
      // {
      //   label: "My Carpark",
      //   value: "4",
      // },
      // {
      //   label: "My QR ID",
      //   value: "5",
      // },
      {
        label: "Registered Activity",
        value: "6",
      },
    ],
    actSub: [
      {
        label: "My Carpark",
        value: "1",
      },
      {
        label: "My QR ID",
        value: "2",
      },
      {
        label: "Registered Activity",
        value: "3",
      },
    ],
  },
  {
    label: "เกมส์",
    value: "3",
    subCate: [
      {
        label: "เกมส์ on the event day",
        value: "7",
      },
    ],
    actSub: [
      {
        label: "แสดงเฉพาะรายการที่ Active",
        value: "11",
      },
    ],
  },
  {
    label: "แบบสอบถาม",
    value: "4",
    subCate: [
      {
        label: "active",
        value: "8",
      },
    ],
    actSub: [
      {
        label: "แสดงเฉพาะรายการที่ Active",
        value: "12",
      },
    ],
  },
];

ShortcutForm.propTypes = {};

export default ShortcutForm;
